
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"16","viewBox":"140 -860 760 760","width":"16","fill":"#5f6368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8F7A61","d":"M602.08-626.23h139.46-139.46zm-382.04 0h342.54-24.81 8.61-326.34zm5.31-47.96h509.42l-57.62-61.54q-1.92-1.92-4.42-3.08-2.5-1.15-5.19-1.15H291.99q-2.69 0-5.19 1.15-2.5 1.16-4.42 3.08l-57.03 61.54zm180.73 227.84l73.92-36.8 74.12 36.8v-179.88H406.08v179.88zm157.8 274.27H234.77q-26.03 0-44.36-18.18t-18.33-43.7v-431.96q0-11.64 4.96-23.09t13.15-19.46l59.55-61.99q9.38-9.16 19.63-13.31 10.24-4.15 22.61-4.15h375.27q12.72 0 23.44 4.1 10.71 4.11 19.35 13.4l59.73 62.5q9.23 8.39 13.69 19.91 4.46 11.52 4.46 23.24v143q-4.16.98-8.61 2.14-4.46 1.17-8.81 1.17-7.58 0-15.27.5-7.69.5-15.27 1.5v-109.77H602.08v178.31Q591.3-435.24 580.29-419q-11.02 16.23-17.71 31.69l-82.58-42-121.88 61.19v-258.11H220.04v393.88q0 5.39 3.46 8.85t8.85 3.46h314.03q2.99 12.45 7.71 24.38t9.79 23.58zm180.85 20v-108h-108v-47.96h108v-108h47.96v108h108v47.96h-108v108h-47.96z"}})])
          )
        }
      }
    